import React from "react";
import { Input } from "@/components/atoms/Input";
import { Label } from "@/components/atoms/Label";
import type { BaseFieldProps, FieldConfig } from "./types";

interface ColorFieldProps extends BaseFieldProps {
  field: FieldConfig;
}

const ColorField: React.FC<ColorFieldProps> = ({
  fieldName,
  label,
  placeholder,
  disabled,
  className,
  required,
  hasError,
  validationMessage,
  formData,
  handleChange,
  field,
}) => {
  return (
    <div key={fieldName} className="flex-1 min-w-80 max-w-md">
      {label && (
        <Label
          htmlFor={fieldName}
          className={`peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium ${field.labelClassName || ""}`}
        >
          {label}
          {field.showAsterisk !== false && required && (
            <span className="text-secondary-main ml-1">*</span>
          )}
        </Label>
      )}
      <div className="flex gap-2 items-center mt-1">
        <Input
          type="color"
          value={formData[fieldName] || "#000000"}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleChange(fieldName, e.target.value)
          }
          disabled={disabled}
          classType="admin"
          className={`w-20 h-10 p-1 cursor-pointer ${className || ""} ${hasError ? "border-secondary-main focus:border-secondary-main focus:ring-secondary-main" : ""}`}
        />
        <Input
          type="text"
          value={formData[fieldName] || ""}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            // Basic hex color validation
            if (value === "" || /^#[0-9A-Fa-f]{0,6}$/.test(value)) {
              handleChange(fieldName, value);
            }
          }}
          placeholder={placeholder || "#000000"}
          disabled={disabled}
          classType="admin"
          className={`flex-1 text-base md:text-sm placeholder:text-sm ${className || ""} ${hasError ? "border-secondary-main focus:border-secondary-main focus:ring-secondary-main" : ""}`}
        />
      </div>
      {hasError && (
        <p className="text-secondary-main text-body-4-medium mt-1">
          {validationMessage || "This field is required"}
        </p>
      )}
    </div>
  );
};

export default ColorField;


